import Radio from '@mui/material/Radio';
import Box from '@mui/material/Box';
import { updateSurveyToFillQuestion } from '../../../../../../store/actions/dataEntryFillASurveyActions';
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FormControl, FormControlLabel, RadioGroup, Card, CardMedia, Typography } from '@mui/material';
import './SurveySingleChoiceQuestion.css';

const SurveySingleChoiceQuestion = ({ question, onChangeAlert, disabled }) => {
  const { variant, options, id, answer, error, config = {} } = question;
  const dispatch = useDispatch();
  const [value, setValue] = useState(answer && answer.length ? answer[0] : null);
  const layout = config?.layout || 'vertical';

  const onChangeInputValue = (newValue) => {
    let castValue = newValue;

    if (variant?.value === 'boolean') {
      castValue = newValue === 'true';
    } else if (variant?.value === 'numeric') {
      castValue = Number(newValue || 0);
    }

    dispatch(
      updateSurveyToFillQuestion({
        questionId: id,
        newData: { answer: newValue ? [castValue] : [], error: null }
      })
    );

    onChangeAlert();
  };

  useEffect(() => {
    setValue(answer && answer.length ? answer[0] : null);
  }, [answer]);

  return (
    <>
      {variant?.value === 'image' ? (
        <Box className='survey-image-question'>
          <FormControl component='fieldset' className='survey-image-question__form-control'>
            <RadioGroup
              aria-labelledby='choose-image-option'
              name='image-radio-buttons-group'
              value={value}
              onChange={(evt) => onChangeInputValue(evt.target.value)}
              className='survey-image-question__radio-group'
            >
              <Box className='survey-image-question__options-container'>
                {options &&
                  options.map((item, index) => {
                    const isSelected = item?.value === value;
                    return (
                      <Box key={index} className='survey-image-question__option-wrapper'>
                        <Card
                          className={`survey-image-question__option-card ${
                            isSelected ? 'survey-image-question__option-card--selected' : ''
                          } ${disabled ? 'survey-image-question__option-card--disabled' : ''}`}
                          onClick={() => !disabled && onChangeInputValue(item?.value)}
                        >
                          {item?.image && (
                            <CardMedia
                              component='img'
                              image={item.image}
                              alt={item?.option || `Option ${index + 1}`}
                              className='survey-image-question__option-image'
                            />
                          )}
                          {item?.option && (
                            <Box className='survey-image-question__option-content'>
                              <FormControlLabel
                                value={item?.value}
                                control={
                                  <Radio
                                    checked={isSelected}
                                    style={{ color: '#32668D' }}
                                    disabled={disabled}
                                  />
                                }
                                label=''
                                className='survey-image-question__radio-label'
                              />
                              <Typography variant='body2' className='survey-image-question__option-text'>
                                {item.option}
                              </Typography>
                            </Box>
                          )}
                        </Card>
                      </Box>
                    );
                  })}
              </Box>
            </RadioGroup>
          </FormControl>
          {error && <p className='survey-question__error-hint'>{error}</p>}
        </Box>
      ) : (
        <div>
          <FormControl>
            {layout === 'horizontal' ? (
              <RadioGroup
                aria-labelledby='choose-a-option'
                name='radio-buttons-group'
                value={value}
                onChange={(evt) => onChangeInputValue(evt.target.value)}
                sx={{
                  flexDirection: 'row',
                  gap: 3,
                  flexWrap: 'wrap'
                }}
              >
                {options &&
                  options.map((item, index) => {
                    return (
                      <Box
                        key={index}
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: 0.5,
                          minWidth: 'fit-content'
                        }}
                      >
                        <Typography
                          variant='body2'
                          sx={{
                            textAlign: 'center',
                            minHeight: '20px',
                            color: disabled ? '#00000061' : '#000000DE'
                          }}
                        >
                          {item?.option || ''}
                        </Typography>
                        <Radio
                          value={item?.value}
                          checked={item?.value === value}
                          style={{ color: '#32668D' }}
                          disabled={disabled}
                          sx={{ padding: '4px' }}
                        />
                      </Box>
                    );
                  })}
              </RadioGroup>
            ) : (
              <RadioGroup
                aria-labelledby='choose-a-option'
                name='radio-buttons-group'
                value={value}
                onChange={(evt) => onChangeInputValue(evt.target.value)}
              >
                {options &&
                  options.map((item, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        value={item?.value}
                        control={
                          <Radio
                            checked={item?.value === value}
                            style={{ color: '#32668D' }}
                            disabled={disabled}
                          />
                        }
                        label={item?.option}
                      />
                    );
                  })}
              </RadioGroup>
            )}
          </FormControl>
          {error && <p className='survey-question__error-hint'>{error}</p>}
        </div>
      )}
    </>
  );
};

export default SurveySingleChoiceQuestion;